// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Mg1l","header":"ReportDetails_header__1AaaA","title":"ReportDetails_title__30Oxo","left":"ReportDetails_left__2Wpsl"};